import React from "react";
import { CataloguePath } from "routes/createContent/paths";
import { useListLessons } from "routes/createContent/api/useListLessons";
import { useDeleteLesson } from "routes/createContent/api/useDeleteLesson";
import { LessonListItemDto } from "routes/createContent/api/lessonDtos";
import { CatalogueList, catalogueQuery, useCatalogueListControls } from "routes/createContent/components/CatalogueList";

type LessonsListProps = {
  pickerMode?: boolean;
  checkedIds?: number[];
  onPickToggle?: (lesson: LessonListItemDto) => void;
  onPreview?: (lessonId: number) => void;
};

const LessonsList: React.VFC<LessonsListProps> = props => {
  const controls = useCatalogueListControls();
  const query = useListLessons(catalogueQuery(controls));

  return (
    <CatalogueList
      {...props}
      kind="lesson"
      title="Lessons"
      noun="lesson"
      newPath={CataloguePath.Lessons_New}
      editPath={id => CataloguePath.Lessons_Edit.replace(":id", String(id))}
      controls={controls}
      query={query}
      deletion={useDeleteLesson()}
      toItem={lesson => ({
        id: lesson.id,
        name: lesson.name,
        title: lesson.title ?? "",
        image: lesson.image_url ?? "",
        target_joints: lesson.target_joints,
        updated_at: lesson.updated_at,
        creator_id: lesson.creator_id,
        rollout: lesson.rollout,
      })}
    />
  );
};

export default LessonsList;
